// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: _5AOERmbtp

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import SectionModeIcon from "../../SectionModeIcon"; // plasmic-import: 6rK5Xe1UAz/component
import FeedModeIcon from "../../FeedModeIcon"; // plasmic-import: 12VCshRIS_/component
import GridModeIcon from "../../GridModeIcon"; // plasmic-import: 5JnDz-tqZ8/component
import SurpriseModeIcon from "../../SurpriseModeIcon"; // plasmic-import: M94oJWBrxO/component
import HubSelection from "../../HubSelection"; // plasmic-import: Xb5xo2JxQe/component
import Title from "../../Title"; // plasmic-import: LHZTBNzdnP/component
import HubCreation from "../../HubCreation"; // plasmic-import: z5fIHof2db/component
import Checklist from "../../Checklist"; // plasmic-import: xmtlGTX1K1/component

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicModalContent.module.css"; // plasmic-import: _5AOERmbtp/css

createPlasmicElementProxy;

export type PlasmicModalContent__VariantMembers = {
  hubCreationPanel: "hubCreationPanel";
};
export type PlasmicModalContent__VariantsArgs = {
  hubCreationPanel?: SingleBooleanChoiceArg<"hubCreationPanel">;
};
type VariantPropType = keyof PlasmicModalContent__VariantsArgs;
export const PlasmicModalContent__VariantProps = new Array<VariantPropType>(
  "hubCreationPanel"
);

export type PlasmicModalContent__ArgsType = {
  viewMode?: React.ReactNode;
};
type ArgPropType = keyof PlasmicModalContent__ArgsType;
export const PlasmicModalContent__ArgProps = new Array<ArgPropType>("viewMode");

export type PlasmicModalContent__OverridesType = {
  root?: p.Flex<"div">;
  modeInfo?: p.Flex<"div">;
  modeSwitcher?: p.Flex<"div">;
  sectionModeIcon?: p.Flex<typeof SectionModeIcon>;
  feedModeIcon?: p.Flex<typeof FeedModeIcon>;
  gridModeIcon?: p.Flex<typeof GridModeIcon>;
  surpriseModeIcon?: p.Flex<typeof SurpriseModeIcon>;
  button?: p.Flex<"button">;
  text?: p.Flex<"div">;
  img?: p.Flex<typeof p.PlasmicImg>;
  hubSelection?: p.Flex<typeof HubSelection>;
  title?: p.Flex<typeof Title>;
  hubTitle2?: p.Flex<"div">;
  hubCreation?: p.Flex<typeof HubCreation>;
  checklist?: p.Flex<typeof Checklist>;
};

export interface DefaultModalContentProps {
  viewMode?: React.ReactNode;
  hubCreationPanel?: SingleBooleanChoiceArg<"hubCreationPanel">;
  className?: string;
}

const $$ = {};

function PlasmicModalContent__RenderFunc(props: {
  variants: PlasmicModalContent__VariantsArgs;
  args: PlasmicModalContent__ArgsType;
  overrides: PlasmicModalContent__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "hubCreationPanel",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          $props.hubCreationPanel
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  return (
    <p.Stack
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [sty.roothubCreationPanel]: hasVariant(
            $state,
            "hubCreationPanel",
            "hubCreationPanel"
          )
        }
      )}
    >
      <p.Stack
        as={"div"}
        data-plasmic-name={"modeInfo"}
        data-plasmic-override={overrides.modeInfo}
        hasGap={true}
        className={classNames(projectcss.all, sty.modeInfo, {
          [sty.modeInfohubCreationPanel]: hasVariant(
            $state,
            "hubCreationPanel",
            "hubCreationPanel"
          )
        })}
      >
        <p.Stack
          as={"div"}
          data-plasmic-name={"modeSwitcher"}
          data-plasmic-override={overrides.modeSwitcher}
          hasGap={true}
          className={classNames(projectcss.all, sty.modeSwitcher, {
            [sty.modeSwitcherhubCreationPanel]: hasVariant(
              $state,
              "hubCreationPanel",
              "hubCreationPanel"
            )
          })}
        >
          <SectionModeIcon
            data-plasmic-name={"sectionModeIcon"}
            data-plasmic-override={overrides.sectionModeIcon}
            className={classNames("__wab_instance", sty.sectionModeIcon)}
            selected={true}
          />

          <FeedModeIcon
            data-plasmic-name={"feedModeIcon"}
            data-plasmic-override={overrides.feedModeIcon}
            className={classNames("__wab_instance", sty.feedModeIcon)}
            color={[]}
          />

          <GridModeIcon
            data-plasmic-name={"gridModeIcon"}
            data-plasmic-override={overrides.gridModeIcon}
            className={classNames("__wab_instance", sty.gridModeIcon)}
            color={"red"}
          />

          <SurpriseModeIcon
            data-plasmic-name={"surpriseModeIcon"}
            data-plasmic-override={overrides.surpriseModeIcon}
            className={classNames("__wab_instance", sty.surpriseModeIcon)}
            color={"red"}
          />
        </p.Stack>
        {p.renderPlasmicSlot({
          defaultContents: (
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__jAkL
              )}
            >
              {"Section Mode "}
            </div>
          ),
          value: args.viewMode,
          className: classNames(sty.slotTargetViewMode)
        })}
        <p.Stack
          as={"button"}
          data-plasmic-name={"button"}
          data-plasmic-override={overrides.button}
          hasGap={true}
          className={classNames(projectcss.all, projectcss.button, sty.button)}
        >
          <div
            data-plasmic-name={"text"}
            data-plasmic-override={overrides.text}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text
            )}
          >
            {"View Settings"}
          </div>
          <p.PlasmicImg
            data-plasmic-name={"img"}
            data-plasmic-override={overrides.img}
            alt={""}
            className={classNames(sty.img)}
            displayHeight={"14.692px"}
            displayMaxHeight={"none"}
            displayMaxWidth={"none"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"16.528px"}
            loader={"plasmic"}
            src={{
              src: "https://site-assets.plasmic.app/abf1453dae3c4abb098a0feb3b193b73.svg",
              fullWidth: 173,
              fullHeight: 150,
              aspectRatio: 1.15
            }}
          />
        </p.Stack>
      </p.Stack>
      <HubSelection
        data-plasmic-name={"hubSelection"}
        data-plasmic-override={overrides.hubSelection}
        blurContent={
          hasVariant($state, "hubCreationPanel", "hubCreationPanel")
            ? true
            : undefined
        }
        className={classNames("__wab_instance", sty.hubSelection, {
          [sty.hubSelectionhubCreationPanel]: hasVariant(
            $state,
            "hubCreationPanel",
            "hubCreationPanel"
          )
        })}
        hubList={null}
        hubTitle={
          <Title
            data-plasmic-name={"title"}
            data-plasmic-override={overrides.title}
            className={classNames("__wab_instance", sty.title)}
            hubTitle={
              <div
                data-plasmic-name={"hubTitle2"}
                data-plasmic-override={overrides.hubTitle2}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.hubTitle2,
                  {
                    [sty.hubTitle2hubCreationPanel]: hasVariant(
                      $state,
                      "hubCreationPanel",
                      "hubCreationPanel"
                    )
                  }
                )}
              >
                {"Welcome"}
              </div>
            }
          />
        }
        scrollableList={true}
        showHubCreationPanel={
          hasVariant($state, "hubCreationPanel", "hubCreationPanel")
            ? true
            : undefined
        }
      />

      <HubCreation
        data-plasmic-name={"hubCreation"}
        data-plasmic-override={overrides.hubCreation}
        className={classNames("__wab_instance", sty.hubCreation, {
          [sty.hubCreationhubCreationPanel]: hasVariant(
            $state,
            "hubCreationPanel",
            "hubCreationPanel"
          )
        })}
      />

      <Checklist
        data-plasmic-name={"checklist"}
        data-plasmic-override={overrides.checklist}
        className={classNames("__wab_instance", sty.checklist, {
          [sty.checklisthubCreationPanel]: hasVariant(
            $state,
            "hubCreationPanel",
            "hubCreationPanel"
          )
        })}
      />
    </p.Stack>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "modeInfo",
    "modeSwitcher",
    "sectionModeIcon",
    "feedModeIcon",
    "gridModeIcon",
    "surpriseModeIcon",
    "button",
    "text",
    "img",
    "hubSelection",
    "title",
    "hubTitle2",
    "hubCreation",
    "checklist"
  ],
  modeInfo: [
    "modeInfo",
    "modeSwitcher",
    "sectionModeIcon",
    "feedModeIcon",
    "gridModeIcon",
    "surpriseModeIcon",
    "button",
    "text",
    "img"
  ],
  modeSwitcher: [
    "modeSwitcher",
    "sectionModeIcon",
    "feedModeIcon",
    "gridModeIcon",
    "surpriseModeIcon"
  ],
  sectionModeIcon: ["sectionModeIcon"],
  feedModeIcon: ["feedModeIcon"],
  gridModeIcon: ["gridModeIcon"],
  surpriseModeIcon: ["surpriseModeIcon"],
  button: ["button", "text", "img"],
  text: ["text"],
  img: ["img"],
  hubSelection: ["hubSelection", "title", "hubTitle2"],
  title: ["title", "hubTitle2"],
  hubTitle2: ["hubTitle2"],
  hubCreation: ["hubCreation"],
  checklist: ["checklist"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  modeInfo: "div";
  modeSwitcher: "div";
  sectionModeIcon: typeof SectionModeIcon;
  feedModeIcon: typeof FeedModeIcon;
  gridModeIcon: typeof GridModeIcon;
  surpriseModeIcon: typeof SurpriseModeIcon;
  button: "button";
  text: "div";
  img: typeof p.PlasmicImg;
  hubSelection: typeof HubSelection;
  title: typeof Title;
  hubTitle2: "div";
  hubCreation: typeof HubCreation;
  checklist: typeof Checklist;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicModalContent__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicModalContent__VariantsArgs;
    args?: PlasmicModalContent__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicModalContent__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicModalContent__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicModalContent__ArgProps,
          internalVariantPropNames: PlasmicModalContent__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicModalContent__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicModalContent";
  } else {
    func.displayName = `PlasmicModalContent.${nodeName}`;
  }
  return func;
}

export const PlasmicModalContent = Object.assign(
  // Top-level PlasmicModalContent renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    modeInfo: makeNodeComponent("modeInfo"),
    modeSwitcher: makeNodeComponent("modeSwitcher"),
    sectionModeIcon: makeNodeComponent("sectionModeIcon"),
    feedModeIcon: makeNodeComponent("feedModeIcon"),
    gridModeIcon: makeNodeComponent("gridModeIcon"),
    surpriseModeIcon: makeNodeComponent("surpriseModeIcon"),
    button: makeNodeComponent("button"),
    text: makeNodeComponent("text"),
    img: makeNodeComponent("img"),
    hubSelection: makeNodeComponent("hubSelection"),
    title: makeNodeComponent("title"),
    hubTitle2: makeNodeComponent("hubTitle2"),
    hubCreation: makeNodeComponent("hubCreation"),
    checklist: makeNodeComponent("checklist"),

    // Metadata about props expected for PlasmicModalContent
    internalVariantProps: PlasmicModalContent__VariantProps,
    internalArgProps: PlasmicModalContent__ArgProps
  }
);

export default PlasmicModalContent;
/* prettier-ignore-end */
